import { fetchApi } from '@/config/axiosSetting';
import { IGetBodyVehicleDamageAmount } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleDamageAmount/getBodyVehicleDamageAmount.type';

export const getBodyVehicleDamageAmountQueryFunction = (
  params: IGetBodyVehicleDamageAmount,
): Promise<number> => {
  return fetchApi.get(
    `/body/reports/${params.id}/adjusting/vehicle_damage_amount/`,
    {
      params: {
        id: params.id,
        source: params.source,
      },
    },
  );
};
